export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ10.7cfd7ee3.mp3";